var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopRightCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 616,
    height: 617,
    viewBox: "0 0 616 617",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616 308.5C616 478.88 478.104 617 308 617C137.896 617 0 478.88 0 308.5C0 138.12 137.896 0 308 0C478.104 0 616 138.12 616 308.5ZM35.3186 308.5C35.3186 459.342 157.402 581.624 308 581.624C458.598 581.624 580.681 459.342 580.681 308.5C580.681 157.658 458.598 35.3759 308 35.3759C157.402 35.3759 35.3186 157.658 35.3186 308.5Z",
    fill: "url(#paint0_linear_4_426)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4_426",
    x: 0,
    y: 0,
    width: 620,
    height: 621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4_426"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_426",
    x1: 78.6896,
    y1: 109.281,
    x2: 555.248,
    y2: 467.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightCircular);
export default __webpack_public_path__ + "static/media/topRightCircular.5b8a092254d48c613849372797a7bdf9.svg";
export { ForwardRef as ReactComponent };